import { render, staticRenderFns } from "./ChoiceProduction.vue?vue&type=template&id=2df3c3ed&scoped=true&"
import script from "./ChoiceProduction.vue?vue&type=script&lang=js&"
export * from "./ChoiceProduction.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceProduction.vue?vue&type=style&index=0&id=2df3c3ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df3c3ed",
  null
  
)

export default component.exports